import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const conductorOne = defineConnector({
  identifier: "conductorOne",
  name: "ConductorOne",
  tagLine: "Identity governance and access",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.conductor\\.one/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in ConductorOne",
      items: [
        {
          kind: "markdown",
          content: `1. In ConductorOne, go to **Settings › API Keys**
2. Click “Create API Key”
3. Copy the Client ID and Client Secret`,
        },
      ],
    },
    {
      title: "Enter your ConductorOne details",
      items: [
        {
          kind: "hostname",
          label: "Tenant subdomain",
          required: true,
          placeholder: "acme",
          target: { kind: "configuration", field: "tenant" },
          helperText:
            "Your ConductorOne tenant name (e.g., “acme” for acme.conductor.one).",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ tenant }) => `https://${tenant}/auth/v1/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ tenant }) => `https://${tenant}/api/v1/auth/introspect`,
  },
  publicEnvVars: ({ tenant }) => ({
    CONDUCTOR_ONE_URL: tenant ? `https://${tenant}` : "",
  }),
});
